import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Thumbs, Controller } from 'swiper';
import { GalleryWrapper, SlideWrapper } from './styles';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation, Thumbs, Controller]);

const Gallery = ({ images }) => {
  const [firstSwiper, setFirstSwiper] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const slides = images.map((i) => (
    <SwiperSlide key={i.id}>
      <SlideWrapper bgImage={i.url} />
    </SwiperSlide>
  ));

  const thumbs = images.map((i) => (
    <SwiperSlide key={i.id}>
      <SlideWrapper bgImage={i.url} thumb />
    </SwiperSlide>
  ));

  return (
    <GalleryWrapper>
      <Swiper
        id="main"
        initialSlide={0}
        navigation
        spaceBetween={10}
        slidesPerView={1}
        onSwiper={setFirstSwiper}
        controller={{ control: thumbsSwiper }}
      >
        {slides}
      </Swiper>

      <Swiper
        id="thumbs"
        initialSlide={0}
        spaceBetween={10}
        slidesPerView={3}
        slideToClickedSlide="true"
        centeredSlides="true"
        onSwiper={setThumbsSwiper}
        controller={{ control: firstSwiper }}
      >
        {thumbs}
      </Swiper>
    </GalleryWrapper>
  );
};

Gallery.defaultProps = {
  images: [],
};

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape()),
};

export default Gallery;
